import { VisitTemplate, VisitTemplateDetailType } from '@dreryk/egabinet-visit-frontend-api';

import { TranslatableText, useTranslate } from '@dreryk/react-common';
import { FormLabel, TextEditor } from '@dreryk/react-components';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { StyledVisitTemplateReadOnlyField } from './VisitTemplateReadOnlyField.styled';
import { StyledVisitTemplateReadOnlyText } from './VisitTemplateReadOnlyText.styled';

type VisitTemplateReadOnlyFieldProps = {
   readonly value?: string;
   readonly label: TranslatableText;
   readonly placeholder: TranslatableText;
   readonly onInsert?: (
      templateId: VisitTemplate['id'],
      templateDetailType: VisitTemplateDetailType[]
   ) => Promise<void>;
   readonly templateId?: VisitTemplate['id'];
   readonly detailType?: VisitTemplateDetailType;
};

export const VisitTemplateReadOnlyField = (props: VisitTemplateReadOnlyFieldProps): JSX.Element => {
   const translate = useTranslate();
   return (
      <StyledVisitTemplateReadOnlyField direction={'column'}>
         <FormLabel
            label={props.label}
            testId={'visitTemplateReadOnly'}
            suffixIcon={
               props.onInsert ? (
                  <FormsTemplates.ReadOnlyInsertLink
                     testId={props.detailType ?? 'insertToVisit'}
                     onClick={async () => {
                        if (props.templateId && props.detailType) {
                           await props.onInsert!(props.templateId, [props.detailType]);
                        }
                     }}
                  />
               ) : undefined
            }
         />
         <StyledVisitTemplateReadOnlyText asPlaceholder={!props.value}>
            {props.value ? (
               // eslint-disable-next-line react/no-danger
               <span dangerouslySetInnerHTML={{ __html: TextEditor.sanitize(props.value) }} />
            ) : (
               translate(props.placeholder)
            )}
         </StyledVisitTemplateReadOnlyText>
      </StyledVisitTemplateReadOnlyField>
   );
};
